import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddItemToListMutationVariables = Types.Exact<{
  input: Types.CreateListItemInput;
}>;

export type AddItemToListMutation = {
  __typename?: 'Mutation';
  createListItem: {
    __typename?: 'ListItem';
    id: any;
    createdAt: any;
    value: { __typename?: 'Address'; address: string };
  };
};

export const AddItemToListDocument = gql`
  mutation AddItemToList($input: CreateListItemInput!) {
    createListItem(input: $input) {
      id
      value {
        ... on Address {
          address
        }
      }
      createdAt
    }
  }
`;
export type AddItemToListMutationFn = Apollo.MutationFunction<
  AddItemToListMutation,
  AddItemToListMutationVariables
>;

/**
 * __useAddItemToListMutation__
 *
 * To run a mutation, you first call `useAddItemToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToListMutation, { data, loading, error }] = useAddItemToListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemToListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddItemToListMutation,
    AddItemToListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddItemToListMutation,
    AddItemToListMutationVariables
  >(AddItemToListDocument, options);
}
export type AddItemToListMutationHookResult = ReturnType<
  typeof useAddItemToListMutation
>;
export type AddItemToListMutationResult =
  Apollo.MutationResult<AddItemToListMutation>;
export type AddItemToListMutationOptions = Apollo.BaseMutationOptions<
  AddItemToListMutation,
  AddItemToListMutationVariables
>;
